import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export enum BillingQuotePeriod {
  annual = 'annual',
  monthly = 'monthly',
}

export enum BillingQuotePlanType {
  regular = 'regular',
  payg = 'payg',
  bucket = 'bucket',
}

export enum BillingQuoteCurrency {
  GBP = 'GBP',
  EUR = 'EUR',
  USD = 'USD',
  AUD = 'AUD',
  CAD = 'CAD',
  NZD = 'NZD',
}

export default class BillingQuoteModel extends Model {
  @attr('number') amount!: number;
  @attr('string') currency!: BillingQuoteCurrency;
  @attr('string') period!: BillingQuotePeriod;
  @attr('string') planType!: BillingQuotePlanType;
  @attr('number') commission!: number | null;
  @attr('number') numberOfProperties!: number;
  @attr('boolean') airdnaPlan!: boolean;
  @attr('number') numberOfPropertiesIncluded!: number;
  @attr('string') planTier!: string;
  @attr('number') minProperties!: number;
  @attr('number') maxProperties!: number | null;
  @attr('boolean') available!: boolean;
  @attr('boolean') active!: boolean;
  @attr('array') bundledAddons!: string[];

  @cached
  get isAnnual(): boolean {
    return this.period === BillingQuotePeriod.annual;
  }

  @cached
  get isMonthly(): boolean {
    return this.period === BillingQuotePeriod.monthly;
  }

  @cached
  get isAirdnaPlan(): boolean {
    return this.airdnaPlan;
  }

  @cached
  get isPayg(): boolean {
    return this.planType === BillingQuotePlanType.payg;
  }

  @cached
  get isRegular(): boolean {
    return this.planType === BillingQuotePlanType.regular;
  }

  @cached
  get isBucket(): boolean {
    return this.planType === BillingQuotePlanType.bucket;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'billing-quote': BillingQuoteModel;
  }
}
